module.exports = __webpack_public_path__ + "img/vendor_detail_bg.8d8ac9f4.png";